import React from 'react';
import { useSelector } from 'react-redux';
import ProductTile from '@nykaa/product-card-desktop';
import styled from 'App/styled';
import ActionWrapper from 'components/CardAction';
import { ProductRenderProps } from 'types/product';
import CAVList from '../CustomerAlsoViewed';
import Description from '../Description';
import ReviewsAndQuestions from '../ReviewsAndQuestions';
import FirstVisitInternational from 'components/InternationalShippingInfo';
import { State } from 'store/types';
import { selectCurrentSku } from 'store/product/selector';
import { PageSource } from 'constants/dataLayer';
import { toShowProTag } from 'shared/helpers/utils/product/toShowProTag';
import useShouldDisableCta from 'hooks/Product/action';

interface ProductDetailsProps {
  parentId: string;
  handleShowCAB: () => void;
}
const Container = styled.div`
  display: flex;
  width: 100%;
  position: relative;
`;
const Left = styled.div`
  width: 76%;
  overflow: hidden;
  @media (max-width: 1024px) {
    width: 100%;
  }
`;
const Right = styled.div`
  width: 24%;
  margin-left: ${({ theme }) => theme.spacing.spacing60};
  margin-top: ${({ theme }) => theme.spacing.spacing80};
  padding-top: ${({ theme }) => theme.spacing.spacing240};
  @media (max-width: 1024px) {
    width: 0;
    display: none;
  }
`;
const TileContainer = styled.div`
  position: sticky;
  top: 125px;
`;
const ProductDetails = ({ parentId, handleShowCAB }: ProductDetailsProps) => {
  const currentSku = useSelector((state: State) => selectCurrentSku(state));
  const user = useSelector((state: State) => state.auth?.user);
  const proFlag =
    useSelector((state: State) => state.productPage?.product?.proFlag) || 0;
  const isProUser = !!user.isPro;
  const { earlyAccessData } = currentSku || {};
  const { disablePriveProduct } = earlyAccessData || {};
  const disableCta = useShouldDisableCta();
  const isPro = toShowProTag(!!isProUser, proFlag);
  return (
    <Container>
      <Left>
        <Description />
        <CAVList productId={parentId} />
        <ReviewsAndQuestions />
        <FirstVisitInternational />
      </Left>
      <Right>
        {currentSku?.inStock && (
          <TileContainer>
            <ActionWrapper enableSecondaryTagTracking>
              {({
                handleAddToCart,
                handleSliderAction,
              }: ProductRenderProps) => (
                <ProductTile
                  imageUrl={currentSku?.imageUrl}
                  product={currentSku}
                  showProFlag={isPro}
                  lazyLoadImage={false}
                  positionInList={1}
                  user={user}
                  pageLocation={{ pageType: PageSource.Product }}
                  addToCartCallback={handleAddToCart}
                  size="medium"
                  handleSlider={handleSliderAction}
                  onlyAddToBag
                  showFixedAction
                  handleShowCAB={handleShowCAB}
                  isDisabled={disablePriveProduct && disableCta}
                />
              )}
            </ActionWrapper>
          </TileContainer>
        )}
      </Right>
    </Container>
  );
};
export default ProductDetails;
